import React, { useEffect, useState } from "react";
import Card from "src/components/Cards/Basic";
import { Button, Col, Row } from "react-bootstrap";
import axios from "../../../config/axios";
import moment from "moment";
import { Formik, Form } from "formik";
import { downloadFile } from "../../../global/FileDownloader";

const DepositCardsPage = () => {
  function submitPaymentExport(data) {
    downloadFile(
      `/api/v1/payments.xlsx?date=${moment(data.date).startOf("month")}`,
      `Rechnungen ${moment(data.date).format("YYYY-MM")}.xlsx`
    );
  }

  function submitInvoiceExport(data) {
    downloadFile(
      `/api/v1/invoices.xlsx?status=paid&paid_at_month_date=${moment(
        data.date
      ).startOf("month")}`,
      `Rechnungen ${moment(data.date).format("YYYY-MM")}.xlsx`
    );
  }

  return (
    <>
      <Row>
        <Col xs={12} sm={3}>
          <Card title={`Monatliche Rechnungen`}>
            <Formik
              initialValues={{ date: new Date() }}
              onSubmit={submitInvoiceExport}
            >
              {({ values, handleChange }) => (
                <Form name="booking_setting" autoComplete="false">
                  <input
                    type="month"
                    name="date"
                    onChange={handleChange}
                    value={moment(values.date).format("YYYY-MM")}
                  />
                  <br />
                  <br />
                  <Button type="submit">Rechnungen herunterladen</Button>
                </Form>
              )}
            </Formik>
          </Card>
        </Col>
        <Col xs={12} sm={3}>
          <Card title={`Zahlungen & Rückerstattungen`}>
            <Formik
              initialValues={{ date: new Date() }}
              onSubmit={submitPaymentExport}
            >
              {({ values, handleChange }) => (
                <Form autoComplete="false">
                  <input
                    type="month"
                    name="date"
                    onChange={handleChange}
                    value={moment(values.date).format("YYYY-MM")}
                  />
                  <br />
                  <br />
                  <Button type="submit">Rechnungen herunterladen</Button>
                </Form>
              )}
            </Formik>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DepositCardsPage;
